"use client";

import React from "react";
import { BrewingTeaSvg } from "@/components/shared/Loading";

/**
 * Returns a component to show a lare animated gif
 */
export default function LoadingFullScreen() {
  const [msg, setMsg] = React.useState("Loading...");

  React.useEffect(() => {
    const interval = setInterval(() => {
      setMsg((cur) => {
        if (cur === "Loading...") return "Brewing your cup of tea...";
        else if (cur === "Brewing your cup of tea...")
          return "Retrieving your data...";
        else return "Loading...";
      });
    }, 5000);

    return () => clearInterval(interval);
  });

  return (
    <div className="h-screen flex flex-row space-x-4 items-center justify-center min-h-[500px] animate-pulse">
      <BrewingTeaSvg />

      <h1 className="text-xl mt-8" style={{ height: 48 }}>
        {msg}
      </h1>
    </div>
  );
}
